<template>
  <custom-dialog
    class="add-pay-info-public-step2-dialog"
    :title="model.title"
    width="900px"
    :visible="visible"
    v-on="$listeners"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="content">

        <div class="r">
          <div class="info-preview">
            <div class="title">{{ $t('fms_add_pay_info_public_step2_dialog.xin_xi_yu_lan') }}</div>
            <div class="list">
              <div class="item">
                <div class="key">{{ $t('fms_add_pay_info_public_step2_dialog.zhang_hu_ming_cheng') }}:</div>
                <div class="val">{{copyInfo.accountName}}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('fms_add_pay_info_public_step2_dialog.yin_hang_zhang_hu') }}:</div>
                <div class="val">{{copyInfo.account}}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('fms_add_pay_info_public_step2_dialog.kai_hu_yin_hang') }}:</div>
                <div class="val">{{copyInfo.bank}}</div>
              </div>
              <div class="item">
                <div class="key">{{ $t('fms_add_pay_info_public_step2_dialog.zhuan_zhang_bei_zhu') }}:</div>
                <div class="val">{{copyInfo.remark}} <span class="tips"> (*{{ $t('fms_add_pay_info_public_step2_dialog.dksqbz') }})</span></div>
              </div>
            </div>

            <div class="amount">
              <div class="key">{{ $t('fms_add_pay_info_public_step2_dialog.fu_kuan_jin_e') }}:</div>
              <div class="val"> ￥{{form.totalAmount}}</div>
            </div>

            <el-button
              type="info"
              class="copy"
              @click="onCopy"
            >
              <i class="icon icon-fuzhi"></i>
              <span>{{ $t('fms_add_pay_info_public_step2_dialog.fu_zhi') }}</span>
            </el-button>
          </div>
        </div>
        <div class="l">
          <div class="group">
            <div class="title">{{ $t('fms_add_pay_info_public_step2_dialog.zhuan_zhang_xin_xi') }}</div>
            <div class="info">
              <el-form
                label-position="top"
                :model="form"
                :rules="rules"
                ref="form"
              >

                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item
                      :label="isReverse ? $t('fms_add_pay_info_public_step2_dialog.fu_kuan_fang') : $t('fms_add_pay_info_public_step2_dialog.shou_kuan_fang')"
                      prop="sellerName"
                    >
                      <el-input
                        v-model="form.sellerName"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="isReverse ? $t('fms_add_pay_info_public_step2_dialog.fkfzh') : $t('fms_add_pay_info_public_step2_dialog.skfzh')"
                      prop="sellerAccount"
                      class="row"
                    >
                      <custom-select
                        v-if="dicMap.bank_branch"
                        v-model="form.sellerAccount"
                        url="PartnerBankcardListByOrgId"
                        :params="{orgId:receivableOrgId}"
                        :props="{label:'label', value: 'depositNumber'}"
                        @getList="onSellerAccountGetList"
                        :dataFilter="bankListFilter"
                        ref="sellerBank"
                        :key="sellerBankKey"
                        disabled
                      ></custom-select>
                      <div
                        class="item"
                        @click="showReceivableAccountManage"
                      >{{ $t('fms_add_pay_info_public_step2_dialog.xuan_ze') }}</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item
                      :label="isReverse ? $t('fms_add_pay_info_public_step2_dialog.shou_kuan_fang') : $t('fms_add_pay_info_public_step2_dialog.fu_kuan_fang')"
                      prop="buyerName"
                    >
                      <el-input
                        v-model="form.buyerName"
                        :disabled="true"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="isReverse ? $t('fms_add_pay_info_public_step2_dialog.skfzh') : $t('fms_add_pay_info_public_step2_dialog.fkfzh')"
                      prop="buyerAccount"
                      class="row"
                    >
                      <custom-select
                        v-if="dicMap.bank_branch"
                        v-model="form.buyerAccount"
                        url="PartnerBankcardListByOrgId"
                        :params="{orgId:payableOrgId}"
                        :props="{label:'label', value: 'depositNumber'}"
                        @getList="onBuyerAccountGetList"
                        :dataFilter="bankListFilter"
                        ref="buyBank"
                        :key="buyBankKey"
                        disabled
                      ></custom-select>
                      <div
                        class="item"
                        @click="showPayableAccountManage"
                      >{{ $t('fms_add_pay_info_public_step2_dialog.xuan_ze') }}</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('fms_add_pay_info_public_step2_dialog.ping_zheng_ri_qi')"
                      prop="tradeFinishTime"
                      class="row"
                    >
                      <custom-date-picker
                        v-model="form.tradeFinishTime"
                        :picker-options="beforeToday"
                        type="date"
                        style="width: 100%;"
                        :clearable="false"
                        value-format="YYYY-MM-DD HH:mm:ss"
                      ></custom-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('fms_add_pay_info_public_step2_dialog.fu_kuan_jin_e')"
                      prop="totalAmount"
                      class="row"
                    >
                      <el-input
                        v-model="form.totalAmount"
                        type="number"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item :label="$t('fms_add_pay_info_public_step2_dialog.jiao_yi_ping_zheng')">
                      <t-upload
                        ref="transactionReceipt"
                        :limit="1"
                        :bizId="bizId"
                        :bizType="bizType"
                        v-model="transactionReceipt"
                        :autoUpload="false"
                        type="dragFile"
                        accept="image/*"
                        :isKeepValue="true"
                      ></t-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="info"
        plain
        @click="closeDialog"
      >{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="warning"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <add-bank-card-dialog
      v-if="dialog1Visible"
      @close="dialog1Visible = false"
      :model="dialog1Model"
      @success="updateBankData"
    ></add-bank-card-dialog>
    <add-bank-card-dialog
      v-if="dialog2Visible"
      @close="dialog2Visible = false"
      :model="dialog2Model"
      @success="updatePayAccountBankData"
    ></add-bank-card-dialog>
    <bank-account-manage-dialog
      v-if="payableAccountVisible"
      @close="payableAccountVisible=false"
      :model="payableAccountModel"
      :orgId="payableAccountModel.orgId"
      :isPayableAccountType="payableAccountModel.isPayableAccountType"
      :isPayableOrgan="payableAccountModel.isPayableOrg"
      @confirm="onPayableAccountConfirm"
      @edit="onEditBuyerAccount"
      @add="onAddBuyerAccount"
      :accountManage="accountManage"
    ></bank-account-manage-dialog>
    <bank-account-manage-dialog
      v-if="receivableAccountVisible"
      @close="receivableAccountVisible=false"
      :model="receivableAccountModel"
      :orgId="receivableAccountModel.orgId"
      :isPayableAccountType="receivableAccountModel.isPayableAccountType"
      :isPayableOrgan="receivableAccountModel.isPayableOrg"
      @confirm="onReceivableAccountConfirm"
      @edit="onEditSellerAccount"
      @add="onAddSellerAccount"
      :accountManage="accountManage"
    ></bank-account-manage-dialog>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload.vue';
import addBankCardDialog from '@/pages/crm/components/bankCardDialog';
import bankAccountManageDialog from '@/pages/fms/components/bank_account_manage_dialog';

export default {
  name: 'addPayInfoPublicStep2Dialog',
  mixins: [dialogMixins],
  props: {
    orderNum: [Number, String],
    totalAmount: [Number, String],
    // 付款信息列表长度
    listLen: {
      type: Number,
      default: 0
    },
    paymentCode: [Number, String],
    // 是否反转应付，应收账号显示
    isReverse: {
      type: Boolean,
      default: false
    },
    // false-收款  true-付款
    paymentOrReceivable: {
      type: Boolean,
      default: false
    },
    // 权限-账户管理, 默认有
    accountManage: {
      type: Boolean,
      default: true
    }
  },
  components: {
    tUpload,
    addBankCardDialog,
    bankAccountManageDialog
  },
  computed: {
    rules() {
      return {
        sellerName: { required: true, message: this.$t('Common.com_required') },
        sellerAccount: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) }
        ],
        tradeMethod: { required: true, message: this.$t('Common.com_required') },
        buyerName: { required: true, message: this.$t('Common.com_required') },
        buyerAccount: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]) }
        ],
        totalAmount: { required: true, message: this.$t('Common.com_required'), type: 'string' },
        tradeFinishTime: { required: true, message: this.$t('Common.com_required') }
      };
    },
    bizId() {
      return this.form.tradeId;
    },
    receivableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.data.form.sellerId || outerItem.receivableOrgId;
    },
    payableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.data.form.buyerId || outerItem.payableOrgId;
    },
    buyerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.data.form.buyerName || outerItem.payableOrgName;
    },
    sellerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      return this.model.data.form.sellerName || outerItem.receivableOrgName;
    },
    // 显示账号信息
    accountVisible() {
      if (!this.dicMap.payment_class) {
        return false;
      }
      return this.form.tradeMethod !== this.dicMap.payment_class.cash;
    },
    copyInfo() {
      /**
       * 账户名称
       * 银行账户
       * 开户行
       * 转账备注
       * 付款金额
       */
      const ret = {};
      const {
        buyerAccount,
        sellerAccount,
        // 转账金额
        totalAmount, } = this.form;


      // 账户名称
      ret.accountName = this.isReverse ? this.form.buyerName : this.form.sellerName;

      // 付款人
      ret.buyerAccount = this.isReverse ? sellerAccount : buyerAccount;
      // 收款人
      ret.sellerAccount = this.isReverse ? buyerAccount : sellerAccount;

      // 付款金额
      ret.totalAmount = totalAmount;


      // 转账备注
      ret.remark = this.paymentCode.slice(-6);

      const accountList = this.isReverse ? this.buyerAccountList : this.sellerAccountList;

      const sellerItem = accountList.find(item => item.depositNumber === ret.sellerAccount);
      if (sellerItem) {
        // 开户行
        const bank = this.dicMap.bank_branch[sellerItem.bankCode] || sellerItem.bankName;

        const {
          // 支行
          depositBank,
          // 银行账号
          depositNumber,

        } = sellerItem;


        // 银行账户
        ret.account = depositNumber;
        // 开户行
        ret.bank = `${bank}${depositBank}`;

      }
      return ret;
    },
    // 是否编辑
    isEdit() {
      return this.model.type === 'edit';
    }
  },
  data() {
    return {
      bizType: 'fms.trade.certificate',
      payableAccountVisible: false,
      payableAccountModel: {},

      receivableAccountVisible: false,
      receivableAccountModel: {},
      form: {
        // 收款方
        sellerName: '',
        // 收款方账号
        sellerAccount: '',
        // 交易方式 payment_class
        tradeMethod: '',
        // 付款方
        buyerName: '',
        // 付款方账号
        buyerAccount: '',
        // 交易日期
        tradeFinishTime: '',
        // 交易金额
        totalAmount: '',
        // 交易凭证
        // tradeResult: '',
        // 摘要
        buyerTradeRemark: '',
        tradeId: '',
        buyerId: '',
        sellerId: '',
      },
      transactionReceipt: [],
      addBankModel: {},
      addBankVisible: false,
      sellerAccountList: [],
      buyerAccountList: [],
      updateFileds: [],
      updateFiledsModal: {},
      updateFiledsVisible: false,

      dialog1Visible: false,
      dialog1Model: {},
      dialog2Visible: false,
      dialog2Model: {},
      buyBankKey: 1,
      sellerBankKey: 1,
    };
  },
  methods: {
    onAddBuyerAccount() {
      this.buyBankKey++;
      this.$emit('add:buyer');
    },
    onAddSellerAccount() {
      this.sellerBankKey++;
      this.$emit('add:seller');
    },
    onEditBuyerAccount(form) {
      const { buyerAccount } = this.form;
      const buyerAccountList = this.buyerAccountList;
      const item = buyerAccountList.find(obj => obj.depositNumber === buyerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.form.buyerAccount = form.depositNumber;

          // 让select组件重新加载数据渲染
          this.buyBankKey++;

          // 通知外部列表更新
          this.$emit('edit:buyer', form);
        }
      }
    },
    onEditSellerAccount(form) {
      const { sellerAccount } = this.form;
      const sellerAccountList = this.sellerAccountList;
      const item = sellerAccountList.find(obj => obj.depositNumber === sellerAccount);
      if (item) {
        // 如果已有的账号号码被修改，则要同步最新的账号信息
        if (item.bankcardId === form.bankcardId) {
          this.form.sellerAccount = form.depositNumber;

          // 让select组件重新加载数据渲染
          this.sellerBankKey++;

          // 通知外部列表更新
          this.$emit('edit:seller', form);
        }
      }
    },
    onPayableAccountConfirm(row) {
      this.form.buyerAccount = row.depositNumber;
    },
    showPayableAccountManage() {
      this.payableAccountModel = {
        title: this.form.buyerName,
        orgId: this.payableOrgId,
        isPayableAccountType: true,
        isPayableOrg: this.isPayableOrg(this.payableOrgId)
      };
      this.payableAccountVisible = true;
    },
    onReceivableAccountConfirm(row) {
      this.form.sellerAccount = row.depositNumber;
    },
    showReceivableAccountManage() {
      this.receivableAccountModel = {
        title: this.form.sellerName,
        orgId: this.receivableOrgId,
        isPayableAccountType: false,
        isPayableOrg: this.isPayableOrg(this.payableOrgId)
      };
      this.receivableAccountVisible = true;
    },
    // 更新银行列表
    updateBankData() {
      this.$refs.sellerBank.getSelectList();
      this.$emit('update:sellerBank');
    },
    // 更新银行列表 - 付款方账号
    updatePayAccountBankData() {
      this.$refs.buyBank.getSelectList();
      this.$emit('update:buyerBank');
    },
    addBank() {
      this.dialog1Model.type = 'add';
      if (this.paymentOrReceivable) {
        this.dialog1Model.partnerOrgId = this.form.sellerId;
      }
      this.dialog1Visible = true;
    },
    // 添加银行卡- 付款方账号
    addPayAccountBank() {
      this.dialog2Model.type = 'add';
      if (!this.paymentOrReceivable) {
        this.dialog2Model.partnerOrgId = this.form.buyerId;
      }
      this.dialog2Visible = true;
    },
    onUpdateFieldConfirm(data) {
      this.$setFormatData(this.form, data);
    },
    toChangeField() {
      // 'buyerAccount' 付款方账户, 'sellerAccount' 收款方账户,
      // 'totalAmount' 付款金额, 'tradeFinishTime 付款日期'

      // 如果 transactionReceipt 为空,则只修改：收款方账户，付款金额
      // else 修改：收款方账户，付款金额，付款方账户，付款日期
      if (this.transactionReceipt.length) {
        this.updateFileds = ['buyerAccount', 'sellerAccount', 'totalAmount', 'tradeFinishTime'];
      } else {
        this.updateFileds = ['sellerAccount', 'totalAmount'];
      }

      this.updateFiledsModal = {
        title: this.$t('fms_add_pay_info_public_step2_dialog.xin_xi_geng_gai'),
        data: this.form
      };

      this.updateFiledsVisible = true;
    },
    onConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$refs.transactionReceipt.submit();
          this.closeDialog();
          this.$emit(this.model.type, this.getEmitData());
        }
      });
    },
    getEmitData() {
      // 收款方（卖方）
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      // 付款方（买方）
      const buyerItem = this.buyerAccountList.find(item => item.depositNumber === this.form.buyerAccount);
      const ret = { ...this.form };

      if (buyerItem) {
        ret.buyerBank = buyerItem.depositBank;
      }
      if (sellerItem) {
        ret.sellerBank = sellerItem.depositBank;
      }

      ret.attachs = this.transactionReceipt;

      ret.buyerId = this.payableOrgId;
      ret.sellerId = this.receivableOrgId;
      ret.buyerTradeRemark = this.copyInfo.remark;

      return ret;
    },
    onCopy() {
      const copyInfo = this.copyInfo;
      const ret = [
        // 账户名称
        this.$t('fms_add_pay_info_public_step2_dialog.zhang_hu_ming_chengo', [copyInfo.accountName]),
        // 银行账户
        this.$t('fms_add_pay_info_public_step2_dialog.yin_hang_zhang_huo', [copyInfo.account]),
        // 开户行
        this.$t('fms_add_pay_info_public_step2_dialog.kai_hu_hango', [copyInfo.bank]),
        // 转账备注
        this.$t('fms_add_pay_info_public_step2_dialog.zhuan_zhang_bei_zhuo', [copyInfo.remark]),
        // 付款金额
        this.$t('fms_add_pay_info_public_step2_dialog.fu_kuan_jin_eo', [copyInfo.totalAmount]),
      ];
      this.$copyToClip(ret.join('\r\n'), this.$t('Common.com_copy_success'));

    },
    getRemark(str) {
      if (str && str.length) {
        return str.slice(-6);
      }
      return '';
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/银行/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [
          depositNumber,
          depositBank
        ].join('/');
      });
      return list;
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    closeDialog() {
      this.visible = false;
    },
    init() {
      const form = this.model.data.form;
      const type = this.model.type || 'add';
      this.form.buyerName = this.buyerName;
      this.form.sellerName = this.sellerName;
      this.form.buyerTradeRemark = this.orderNum;
      if (type === 'edit') {
        this.$setFormatData(this.form, form);
        this.form.tradeMethod = String(this.form.tradeMethod);
        if (form.attachs && form.attachs.length) {
          this.transactionReceipt = form.attachs;
        }
        if (this.form.totalAmount) {
          this.form.totalAmount = String(this.form.totalAmount);
        }
      } else {
        // this.form.tradeMethod = this.dicMap.payment_class.public_account;
        if (form.tradeMethod) {
          this.form.tradeMethod = form.tradeMethod;
        }
        if (this.totalAmount) {
          this.form.totalAmount = String(this.totalAmount);
        }
      }
      // 默认银行转账
      if (!this.form.tradeMethod) {
        this.form.tradeMethod = '1';
      }
    },
  },
  mounted() {
    this.getDicMap('bank_branch');
    this.getDicMap('payment_class', () => {
      this.init();
    }, { propKey: 'code', propVal: 'name' });
  },

  beforeCreate() {

  }
};
</script>

<style lang="scss">
.add-pay-info-public-step2-dialog {
  .el-dialog .el-dialog__body .el-form-item__label {
    padding-bottom: 0;
  }
  .row {
    position: relative;
    .el-form-item__content {
      position: static;
    }
    .item {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
        text-decoration: underline;
      }
    }
  }
  .content {
    overflow: hidden;
    .l {
      padding-right: 24px;
      overflow: hidden;

      .group {
        &:nth-child(n + 2) {
          margin-top: 24px;
        }
        > .title {
          font-size: 12px;
          line-height: 17px;
          color: #202945;
          font-weight: bold;
        }

        > .info {
          padding-top: 16px;
          .pay-type {
            overflow: hidden;

            .item {
              height: 48px;
              width: 100%;
              text-align: center;
              line-height: 48px;
              background: #f8f8f8;
              border-radius: 8px;
              box-shadow: 0 0 0 1px rgba(245, 245, 245, 1) inset;
              position: relative;
              overflow: hidden;
              cursor: pointer;

              .tag-checked {
                display: none;
              }

              &.checked {
                background: rgba(0, 160, 217, 0.16);
                box-shadow: 0 0 0 1.5px #00a0d9 inset;

                .label {
                  color: #202945;
                }
                .tag-checked {
                  display: block;
                  position: absolute;
                  top: 0;
                  right: 0;
                  width: 30px;
                  height: 24px;
                  font-size: 24px;
                  line-height: 24px;
                  color: #00a0d9;
                }
              }
              .tag {
                font-size: 15px;
                color: #00a0d9;
              }
              .label {
                padding-left: 10px;
                font-size: 14px;
                color: #4d4d4d;
              }
            }
          }
        }
      }
    }
    .r {
      width: 361px;
      padding: 24px;
      padding-right: 0;
      float: right;

      .info-preview {
        width: 100%;
        overflow: hidden;
        border-radius: 4px;
        border: 1px solid rgba(245, 245, 245, 1);
        border-top: 4px solid #00a0d9;

        padding: 24px 24px 32px 24px;

        > .title {
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          color: #202945;
        }

        > .list {
          margin-top: 24px;
          .item {
            overflow: hidden;
            line-height: 21px;
            font-size: 14px;
            &:nth-child(n + 2) {
              margin-top: 8px;
            }
            .key {
              float: left;
              color: #4d4d4d;
            }
            .val {
              overflow: hidden;
              word-break: break-all;
              padding-left: 16px;
              color: #1a1a1a;
            }
            .tips {
              color: #eb5a5a;
            }
          }
        }

        .amount {
          overflow: hidden;
          line-height: 24px;
          margin-top: 24px;
          .key {
            color: #4d4d4d;
            font-size: 14px;
            float: left;
          }
          .val {
            padding-left: 18px;
            float: left;
            color: #00a0d9;
            font-size: 18px;
            font-weight: bold;
          }
        }

        .copy {
          width: 100%;
          margin-top: 24px;
          span {
            padding-left: 6px;
          }
        }
      }
    }
  }
}
</style>
